import React from "react";
import { Row, Col } from "antd";
import { useIntl } from "react-intl";

import ImportFile from "../../components/import/importFile";
import ImportHeader from "../../components/import/importHeader";
import ConsignmentImportInstructions from "../../components/consignmentImport/consignmentImportInstructions";

const ConsignmentImport = () => {
  const intl = useIntl();
  return (
    <Row>
      <Col>
        <ImportHeader
          what={intl.formatMessage({
            id: "consignment.genitivMultiple",
            defaultMessage: "zásilek",
          })}
        />
        <ImportFile
          showColliDelimiter
          whatFourth={intl.formatMessage({
            id: "consignment.genitiv",
            defaultMessage: "zásilky",
          })}
          entity="consignment"
        >
          <ConsignmentImportInstructions />
        </ImportFile>
      </Col>
    </Row>
  );
};

export default ConsignmentImport;
